import { createContext, useContext } from 'react';

interface AuthContextType {
    user: UserInfo | null;
    loadFailedCode: number | null;
    login: (userData: UserInfo) => void;
    logout: () => Promise<void>;
    loading: boolean;
    addMyLesson: (lessonId: string) => Promise<void>;
    removeMyLesson: (lessonId: string) => Promise<void>;
}

const defaultAuthContext: AuthContextType = {
    user: null,
    loadFailedCode: null,
    login: () => {},
    logout: async () => {},
    loading: true,
    addMyLesson: async () => {},
    removeMyLesson: async () => {},
};

export interface AllowedGrades {
    elementary: string[];
    middleSchool: string[];
}
export interface UserInfo {
    id: string;
    name: string;
    role: string;
    gradeShortCode: string;
    allowedGrades: AllowedGrades;
    myLessons: string[];
}

export const AuthContext = createContext<AuthContextType>(defaultAuthContext);

export const useAuth = () => useContext(AuthContext);
